'use strict';
(() => {
  const initialized = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-hero-motion]').forEach(hero => {
      if (initialized.has(hero)) return;
      const video = hero.querySelector('.hero-video');
      const toggle = hero.querySelector('[data-video-toggle]');
      const soundToggle = hero.querySelector('[data-sound-toggle]');
      if (!video || !toggle) return;
      initialized.add(hero);
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let inView = true;
      let userPaused = false;
      let manuallyPlaying = false;
      const saveData = Boolean(navigator.connection && navigator.connection.saveData);
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('aria-hidden', 'true');
      toggle.hidden = false;
      if (soundToggle) soundToggle.hidden = false;
      function syncButton() {
        const playing = !video.paused && !video.ended;
        toggle.textContent = playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
        toggle.setAttribute('aria-pressed', String(playing));
        if (soundToggle) {
          soundToggle.textContent = video.muted ? soundToggle.dataset.onLabel : soundToggle.dataset.offLabel;
          soundToggle.setAttribute('aria-pressed', String(!video.muted));
        }
      }
      async function play() {
        try { await video.play(); } catch (_) { syncButton(); }
      }
      function update() {
        if (document.hidden || !inView || userPaused || ((motion.matches || saveData) && !manuallyPlaying)) {
          video.pause();
          return;
        }
        play();
      }
      video.addEventListener('playing', () => {
        hero.classList.add('has-playing-video');
        syncButton();
      });
      video.addEventListener('pause', syncButton);
      video.addEventListener('volumechange', syncButton);
      video.addEventListener('ended', () => { userPaused = true; manuallyPlaying = false; syncButton(); });
      video.addEventListener('error', () => {
        hero.classList.remove('has-playing-video');
        toggle.hidden = true;
        if (soundToggle) soundToggle.hidden = true;
      });
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; manuallyPlaying = true; play(); }
        else { userPaused = true; manuallyPlaying = false; video.pause(); }
      });
      if (soundToggle) soundToggle.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) { userPaused = false; manuallyPlaying = true; play(); }
        syncButton();
      });
      motion.addEventListener('change', () => {
        manuallyPlaying = false;
        update();
      });
      document.addEventListener('visibilitychange', update);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          update();
        }, { threshold: 0.15 });
        observer.observe(hero);
      } else update();
      syncButton();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
